import { render } from "./Show.vue?vue&type=template&id=058f8b8f&scoped=true"
import script from "./Show.vue?vue&type=script&lang=ts"
export * from "./Show.vue?vue&type=script&lang=ts"

import "./Show.vue?vue&type=style&index=0&id=058f8b8f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-058f8b8f"

export default script